import { Check, X } from "lucide-react";
import { useEffect, useRef, useState } from "react";
import {
  type OperationCompletion,
  subscribeToOperationCompletions,
} from "./operationCompletion";

export function OperationCompletionDialog() {
  const [queue, setQueue] = useState<OperationCompletion[]>([]);
  const confirmButtonRef = useRef<HTMLButtonElement>(null);
  const completion = queue[0];

  useEffect(
    () =>
      subscribeToOperationCompletions((nextCompletion) => {
        setQueue((currentQueue) => [...currentQueue, nextCompletion]);
      }),
    [],
  );

  useEffect(() => {
    if (!completion) return;
    confirmButtonRef.current?.focus();

    const closeOnEscape = (event: KeyboardEvent) => {
      if (event.key === "Escape") setQueue((currentQueue) => currentQueue.slice(1));
    };

    window.addEventListener("keydown", closeOnEscape);
    return () => window.removeEventListener("keydown", closeOnEscape);
  }, [completion]);

  if (!completion) return null;

  const close = () => setQueue((currentQueue) => currentQueue.slice(1));

  return (
    <div className="operation-completion-backdrop">
      <section
        aria-describedby={`operation-completion-message-${completion.id}`}
        aria-labelledby={`operation-completion-title-${completion.id}`}
        aria-live="assertive"
        aria-modal="true"
        className="operation-completion-dialog"
        role="dialog"
      >
        <button
          aria-label="关闭完成提示"
          className="operation-completion-dialog__close"
          onClick={close}
          type="button"
        >
          <X aria-hidden="true" size={20} />
        </button>

        <span className="operation-completion-dialog__icon" aria-hidden="true">
          <Check size={32} strokeWidth={3} />
        </span>
        <small>操作成功</small>
        <h2 id={`operation-completion-title-${completion.id}`}>{completion.title}</h2>
        <p id={`operation-completion-message-${completion.id}`}>{completion.message}</p>
        <button
          className="v4-button v4-button--primary operation-completion-dialog__confirm"
          onClick={close}
          ref={confirmButtonRef}
          type="button"
        >
          确认
        </button>
      </section>
    </div>
  );
}
